import { combineReducers } from 'redux';

import stepData from './data/stepData';
import ui from './ui';

export default combineReducers({
  ui,
  data: combineReducers({ stepData }),
});
